import { useState, useEffect } from 'react';
import { loadSessionList, saveSessionList } from '../utils/filterStorage';

const useSessionList = (storageKey, defaultList) => {
  const [list, setList] = useState(() => {
    const storedList = loadSessionList(storageKey);
    if (storedList === null) return defaultList;
    return storedList;
  });

  useEffect(() => {
    saveSessionList(storageKey, list);
  }, [storageKey, list]);

  return [list, setList];
};

export default useSessionList;
